@if (train) {
@if (train.isTrainIdFlow) {
<csxwc-realtime-train-details [showCloseButton]="true" (onCloseChange)="close()" [trainID]="train.trainId"
  [isWarroom]="false"></csxwc-realtime-train-details>
}@else{
<csxwc-realtime-train-details [isWarroom]="false" [train]="train" [showCloseButton]="true"
  (onCloseChange)="close()"></csxwc-realtime-train-details>
}
}